import { ServiceArticlePage } from "@/components/ServiceArticlePage";
import { SERVICES } from "@/data/content";
import { DIGITAL_MARKETING_ARTICLE } from "@/data/digitalMarketing";

const service = SERVICES.find((s) => s.slug === "digital-marketing");

export default function DigitalMarketing() {
  return (
    <ServiceArticlePage
      service={service}
      blocks={DIGITAL_MARKETING_ARTICLE}
      overline="Service guide — V"
      lede="Google Ads campaign management and social media marketing for businesses — being found, being remembered, turning attention into customers, and reporting on it honestly every month."
      seoDescription="Digital marketing services from My Geeks LLC: Google Ads campaign management and social media marketing with plain-English monthly reporting. Request a quote."
    />
  );
}
